import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import { useLocation, Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const BreadCrumbs = ({ leadingContent, items }) => {
  const location = useLocation();

  const pathnames = location.pathname
    .split('/')
    .filter((x) => x);

  // Special page titles for routes where the URL words are joined together
  const breadcrumbTitles = {
    btcar: 'FN Car',
    allcars: 'All Cars',
    storelist: 'Store List',
    quantityalert: 'Quantity Alert',
    viewservices: 'View Services',
    teamavailibility: 'Team Availability',
    addservices: 'Add Services',
    transferlist: 'Transfer List',
    addproduct: 'Add Product',
    cashcollection: 'Cash Collection',
    workstationreports: 'Workstation Reports',
    deletesystem: 'Delete System',
    salereport: 'Sale Report',
    freeslots: 'Free Slots',
    contactlist: 'Contact List',
    todaymap: 'Today Map',
    viewbooking: 'View Booking',
    viewquote: 'View Quote',
    workstationview: 'Workstation Booking Enquiry',
    viewsale: 'View Sale',
    contactenquiry: 'Website Enquiry',
    bookingenquiry: 'Mobile Enquiry',
    driverhelper: 'Employee',
    usersbystatus: 'Users Follow Up',
    panelusers: 'Panel Users',
    paymentgateway: 'Payment Gateway',
  };

  const formatBreadcrumb = (text) => {
    if (!text) {
      return 'Home';
    }

    const key = text.toLowerCase();

    if (text === 'car') {
      return 'FN Car';
    }

    if (breadcrumbTitles[key]) {
      return breadcrumbTitles[key];
    }

    // Otherwise automatically format the route name
    return text
      .replace(/[-_]+/g, ' ')
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
  };

  const crumbs = items
    ? items.map((item, index) => {
        const isLast = index === items.length - 1;
        const label = item.label || item.title || '';
        const hasValidTo = item.to && item.to !== '#';

        return {
          label,
          to: isLast || !hasValidTo ? undefined : item.to,
          active: item.active !== undefined ? item.active : isLast,
        };
      })
    : pathnames.map((name, index) => {
        const isLast = index === pathnames.length - 1;

        return {
          label: formatBreadcrumb(name),
          to: isLast
            ? undefined
            : `/${pathnames.slice(0, index + 1).join('/')}`,
          active: isLast,
        };
      });

  return (
    <div
      className="mb-4 d-flex align-items-center"
      style={{ gap: '8px', minHeight: '24px' }}
    >
      {leadingContent && (
        <div
          className="d-flex align-items-center flex-shrink-0"
          style={{ height: '24px', lineHeight: 1 }}
        >
          {leadingContent}
        </div>
      )}

      <Breadcrumb
        className="mb-0 d-flex align-items-center"
        listClassName="mb-0 p-0 bg-transparent align-items-center"
        style={{ whiteSpace: 'nowrap', lineHeight: '24px' }}
      >
        <BreadcrumbItem tag={Link} to="/">
          Home
        </BreadcrumbItem>

        {crumbs.map((crumb) => (
          <BreadcrumbItem
            key={crumb.label}
            active={crumb.active}
            tag={crumb.to ? Link : 'span'}
            to={crumb.to}
          >
            {crumb.label}
          </BreadcrumbItem>
        ))}
      </Breadcrumb>
    </div>
  );
};

BreadCrumbs.propTypes = {
  leadingContent: PropTypes.node,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      title: PropTypes.string,
      to: PropTypes.string,
      active: PropTypes.bool,
    }),
  ),
};

BreadCrumbs.defaultProps = {
  leadingContent: undefined,
  items: undefined,
};

export default BreadCrumbs;
